
const MessageIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M12.8339 4.08362L7.58915 7.42437C7.41117 7.52774 7.20902 7.58219 7.00319 7.58219C6.79737 7.58219 6.59521 7.52774 6.41724 7.42437L1.16724 4.08362" stroke="#475467" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.6672 2.33362H2.3339C1.68957 2.33362 1.16724 2.85595 1.16724 3.50028V10.5003C1.16724 11.1446 1.68957 11.667 2.3339 11.667H11.6672C12.3116 11.667 12.8339 11.1446 12.8339 10.5003V3.50028C12.8339 2.85595 12.3116 2.33362 11.6672 2.33362Z" stroke="#475467" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default MessageIcon